export default {"src":"/_next/static/media/down-filled.da09e5c0.svg","height":5,"width":6,"blurWidth":0,"blurHeight":0};